export default "__VITE_ASSET__254f113f__"